export default __webpack_public_path__ + "static/cofunded-es-7660de50873c47960f668890e2196afd.svg";